import axios from "axios";
import { Message } from "element-ui";
import router from "@/router";
import i18n from "@/locales/i18n";



// 请求拦截器
axios.interceptors.request.use(
  (config) => {
    const loginType=localStorage.getItem('loginType');
    // //debugger
    if(loginType=="group"){
      const token = localStorage.getItem("groupToken");
      token && (config.headers.Authorization = token);
      const userId = localStorage.getItem("groupUserId");
      userId && (config.headers.UserId = userId);
      //console.log("group..........userId["+userId+"]"+"token["+token+"]");
    }
    else {
      const token = localStorage.getItem("token");
      token && (config.headers.Authorization = token);
      const userId = localStorage.getItem("userId");
      userId && (config.headers.UserId = userId);
      //console.log("group..........loginType"+loginType+"userId"+localStorage.getItem("userId")+"token["+localStorage.getItem("token")+"]");
    }
    return config;
  },
  (err) => {
    debugger
    return Promise.reject(err);
  }
);
//响应拦截器
axios.interceptors.response.use(
  
  (data) => {     //code 200
    
    //console.log("响应拦截器200 code "+ data.data.code);
    return data.data;
  },
  
  (err) => {
    //debugger
    if (err.response) {
      //console.log("响应拦截器 err code "+ err.response.data.code);
      switch (err.response.status) {
        case (401, 403):
          localStorage.removeItem("token");
          localStorage.removeItem("userId");
          localStorage.removeItem("groupToken");
          router.replace({
            path: "/login",
            query: { redirect: router.currentRoute.fullPath },
          });
        break;
        default: {
          const message =
            err.response.data.message ||
            i18n.t("error." + err.response.data.code) ||
            "The server is error!";
          Message({ message, center: true });

          //return err.response.data;     //返回错误

        }
      }
    }
    return Promise.reject(err.response.data);
  }

);

axios.defaults.headers = {
  "Content-Type": "application/json;charset=UTF-8",
};

axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL;

export default class Http {
  prefix = "";
  constructor(prefix) {
    this.prefix = prefix;
  }

  get(url, params, headers = {}) {
    return axios.get(this.prefix + url, {
      params,
      headers,
    });
  }

  post(url, data, headers = {}) {
    return axios.post(this.prefix + url, data, headers);
  }

  put(url, data, headers = {}) {
    return axios.put(this.prefix + url, data, headers);
  }

  patch(url, data, headers = {}) {
    return axios.patch(this.prefix + url, data, headers);
  }

  delete(url, data, headers = {}) {
    return axios.delete(this.prefix + url, { data: data }, headers);
  }

  getDownload(url, params, headers = {}) {
    return axios.get(this.prefix + url, {
      params,
      headers,
      //responseType:'blob',
      //responseType: "arraybuffer",
    });
  }
}



